import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { saveAppVersionToCookies } from './redux/common/commonHelpers';
import { Header } from './components/common/Header';
import { getIsLoadingLibrariesEnabled } from './redux/settings/settingsSelector';
import { loadGoogleTagManagerScript } from './common/googleTagManager';
import { InitSettingsForLibraries } from './components/common/InitSettingsForLibraries';
import { applyAndroidWebViewClickFix } from './utils/androidWebViewClickFix';

export const App: React.FC = () => {
  const isLoadingLibrariesEnabled = useSelector(getIsLoadingLibrariesEnabled);
  const location = useLocation();

  React.useEffect(() => {
    saveAppVersionToCookies();
    applyAndroidWebViewClickFix();
  }, []);

  React.useEffect(() => {
    if (!location.pathname.startsWith('/driver/form')) {
      document.documentElement.classList.remove('dark');
      document.documentElement.removeAttribute('data-theme-source');
    }
  }, [location.pathname]);

  React.useEffect(() => {
    if (isLoadingLibrariesEnabled) {
      loadGoogleTagManagerScript();
    }
  }, [isLoadingLibrariesEnabled]);

  return (
    <>
      <InitSettingsForLibraries />
      <Header />
      <Outlet />
    </>
  );
};
